import { createReducer } from "redux-starter-kit";
import {
  startLoadArticlesAction,
  endLoadArticlesAction,
  articlesFailLoadAction,
  updateAnArticleMetaAction
} from "../actions/articleList";

const INIT_STATE = {
  loadedIsPdf: null,
  loadedIssueID: null,
  articleIDs: [],
  articlesDict: {},
  errMsg: null
};

const articleList = createReducer(INIT_STATE, {
  [startLoadArticlesAction]: (state, action) => {
    state.loadedIssueID = null;
    state.articleIDs = [];
    state.articlesDict = {};
    state.errMsg = null;
    state.loadedIsPdf = null;
  },
  [endLoadArticlesAction]: (state, action) => {
    state.loadedIssueID = action.payload.issueID;
    state.articleIDs = action.payload.articles.map(article => article.id);

    for (let i = 0; i < action.payload.articles.length; i++) {
      const article = action.payload.articles[i];
      state.articlesDict[article.id] = article;
    }

    state.errMsg = null;
    state.loadedIsPdf = action.payload.isPdf;
  },
  [articlesFailLoadAction]: (state, action) => {
    state.loadedIssueID = action.payload.issueID;
    state.articleIDs = [];
    state.articlesDict = {};
    state.errMsg = action.payload.errMsg;
    state.loadedIsPdf = action.payload.isPdf;
  },
  [updateAnArticleMetaAction]: (state, action) => {
    const article = state.articlesDict[action.payload.id];

    if (article != null) {
      if (action.payload.is_free != null) {
        article.is_free = action.payload.is_free;
      }

      if (action.payload.is_highlight != null) {
        article.is_highlight = action.payload.is_highlight;
      }

      if (action.payload.is_available != null) {
        article.is_available = action.payload.is_available;
      }
    }
  }
});

export default articleList;
